'use client';

import { use } from 'react';
import { mockResolvers } from '@/mocks/resolvers';

const isBrowser = typeof window !== 'undefined';
const isMockingEnabled = process.env.NEXT_PUBLIC_API_MOCKING === 'enabled';

const mockingEnabledPromise =
  isBrowser && isMockingEnabled
    ? import('@/mocks/browser').then(async ({ worker }) => {
        await worker.start({
          onUnhandledRequest(request) {
            if (
              request.url.includes('_next') ||
              request.url.includes('googleapis.com') ||
              request.url.includes('datadoghq.com') ||
              request.url.includes('growthbook.io')
            ) {
              return;
            }
          },
        });
        worker.use(...mockResolvers);
      })
    : Promise.resolve();

export function MSWProvider({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  if (!isMockingEnabled) {
    return children;
  }
  return <MSWProviderWrapper>{children}</MSWProviderWrapper>;
}

function MSWProviderWrapper({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  use(mockingEnabledPromise);
  return children;
}
